export const Drivers = [
  {
    name: "Lando Norris",
    number: 1,
    team: "McLaren",
  },
  {
    name: "Oscar Piastri",
    number: 81,
    team: "McLaren",
  },
  {
    name: "Charles Leclerc",
    number: 16,
    team: "Ferrari",
  },
  {
    name: "Lewis Hamilton",
    number: 44,
    team: "Ferrari",
  },
  {
    name: "Max Verstappen",
    number: 3,
    team: "Red Bull Racing",
  },
  {
    name: "Isack Hadjar",
    number: 6,
    team: "Red Bull Racing",
  },
  {
    name: "George Russell",
    number: 63,
    team: "Mercedes",
  },
  {
    name: "Andrea Kimi Antonelli",
    number: 12,
    team: "Mercedes",
  },
  {
    name: "Lance Stroll",
    number: 18,
    team: "Aston Martin",
  },
  {
    name: "Fernando Alonso",
    number: 14,
    team: "Aston Martin",
  },
  {
    name: "Franco Colapinto",
    number: 43,
    team: "Alpine",
  },
  {
    name: "Pierre Gasly",
    number: 10,
    team: "Alpine",
  },
  {
    name: "Liam Lawson",
    number: 30,
    team: "Racing Bulls",
  },
  {
    name: "Avrid Lindblad",
    number: 41,
    team: "Racing Bulls",
    rookie: true
  },
  {
    name: "Estaban Ocon",
    number: 31,
    team: "Haas",
  },
  {
    name: "Oliver Bearmean",
    number: 87,
    team: "Haas",
  },
  {
    name: "Alexander Albon",
    number: 23,
    team: "Williams",
  },
  {
    name: "Carlos Sainz",
    number: 55,
    team: "Williams",
  },
  {
    name: "Nico Hulkenberg",
    number: 27,
    team: "Audi",
  },
  {
    name: "Gabriel Bortoleto",
    number: 5,
    team: "Audi",
  },
  {
    name: "Sergio Perez",
    number: 11,
    team: "Cadillac"
  },
  {
    name: "Valterri Botas",
    number: 77,
    team: "Cadillac"
  }
];

export const Rookies = [
  ...Drivers.filter((driver) => driver?.rookie)
];
